import PropTypes from 'prop-types';
import {
  StyledPill,
  StyledPillImg,
  StyledPillText,
  StyledPillIcon,
  StyledPillsWrapper,
  WrapperIcon,
  WrapperIconToogle
} from './style';

const Pills = StyledPillsWrapper;
const Pill = StyledPill;
const PillImg = StyledPillImg;
const PillText = StyledPillText;
const PillTextIcon = StyledPillIcon;

Pill.propTypes = {
  featured: PropTypes.bool
};

Pill.defaultProps = {
  featured: false
};

export {
  Pills,
  Pill,
  PillImg,
  PillText,
  PillTextIcon,
  WrapperIcon,
  WrapperIconToogle
};
